import { render, staticRenderFns } from "./accoundRecord.vue?vue&type=template&id=bde0e39a&"
import script from "./accoundRecord.vue?vue&type=script&lang=js&"
export * from "./accoundRecord.vue?vue&type=script&lang=js&"
import style0 from "./accoundRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports